import StandAloneButtons from './StandAloneButtons';

export default StandAloneButtons;



// WEBPACK FOOTER //
// ./src/components/StandAloneButtons/index.js